import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InfoIcon } from '../../../../components/info-icon';

const WaysCustomCell = ({ field, row }) => {
	if (field === 'id') {
		return (
			<div className="address-cell__id">
				<InfoIcon popupContent={`№${row[field]}`} link={row.link} />
			</div>
		);
	}

	if (field === 'date_from' || field === 'date_to') {
		return row[field] ? new Date(row[field]).toLocaleDateString('ru-RU') : '---';
	}

	if (field === 'name') {
		return (
			<div className="address-cell__name">
				<Link className="address-cell__link" to={row.link}>
					{row[field]}
				</Link>
			</div>
		);
	}

	return row[field];
};

WaysCustomCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { WaysCustomCell };
